export const VAT_RECIPROCAL = 1.05;
export const VAT_UAE = 0.05;